export default __webpack_public_path__ + "static/media/icon-my-profile.35f12d3a.svg";